import cs from '../../messages/dativery.cs.po';
import de from '../../messages/dativery.de.po';
import en from '../../messages/dativery.pot';
import {getLocale as getBasicLocale} from './basicLocales';

let allLocales = {
    /* list locales here */
    'cs': cs,
    'en': en,
    'de': de,
};


let messages = allLocales[getBasicLocale()];
if (!messages) {
    messages = allLocales['en'];
}

export function getMessages(lang) {
	if (lang && allLocales[lang]) {
		return allLocales[lang];
	}

    return messages;
}

export function getMessagesForLocale(locale) {
    return allLocales[locale];
}
